import { firestore } from 'firebase/app';

export const createNewComplaint = (user, photoURL, complaint) => {
  return {
    ...complaint,
    complainant: {
      uid: user.uid,
      email: user.email,
      name: user.displayName,
      mobile: user.userMobile
    },
    created: firestore.FieldValue.serverTimestamp(),
    lastEdited: {
      name: user.displayName,
      role: user.role,
      uid: user.uid
    },
    categories: [],
    subcategories: [],
    sectors: [],
    agent: {
      uid: '',
      email: '',
      name: ''
    },
    createdBy: user.displayName,
    role: user.role,
    status: 'open'
  };
};

export const objectToArray = object => {
  if (object) {
    return Object.entries(object).map(e =>
      Object.assign({}, e[1], { id: e[0] })
    );
  }
};
